module.exports = __webpack_public_path__ + "static/media/geonosis_by_radiusss.4f9537db.svg";